import { Injectable } from '@angular/core';
import { HashKeyServices } from './app.hashkey.services';
import { nkServices } from './app.nkservicios.services';
import { ToastNotificationService } from './toast-notification.service';
import { AppUtilService } from './app.util.service';
import { AtributosService } from './atributos.service';

@Injectable({
  providedIn: 'root'
})
export class TemasService {

  private isDark = false;

  constructor(
    private hashkey:HashKeyServices,
    private servicio:nkServices,
    private notifi:ToastNotificationService,
    private util:AppUtilService,
    private atrb:AtributosService,
    ) {
      let tema;
      let savedTheme;
      if (localStorage.getItem('prfrncs')) {
        tema = parseInt(this.hashkey.decrypt(localStorage.getItem('prfrncs'))) === 2 ? 'dark' : this.hashkey.decrypt(localStorage.getItem('prfrncs')).split(',');
        savedTheme = parseInt(this.hashkey.decrypt(localStorage.getItem('prfrncs'))) === 2 ? tema : tema[3] === '0' ? 'light' :  'dark';
        this.isDark = savedTheme === 'light';
        this.toggleTheme();
      }else{
        this.isDark = false;
        this.toggleTheme();
      }
  }

  async toggleTheme() {
    try {
      if (!this.isDark) {
        this.isDark = true;
        document.body.classList.toggle('dark-theme', true);
        document.body.classList.toggle('light-theme', false);
        return true;
      }else{
        this.isDark = false;
        document.body.classList.toggle('light-theme', true);
        document.body.classList.toggle('dark-theme', false);
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  }
}
